<template>
  <base-modal>
    <z-form ref="form" tag="div">
      <z-form-group class="row form-group--modal align-items-baseline z-form-item">
        <z-form-input class="col-12" :rules="{ required: true }">
          <v-text-field
            v-model="form.name"
            :label="$t('projects.create_task.modal_add_source.form.name')"
            hide-details="auto"
            outlined
            dense
            height="30"
          />
        </z-form-input>
        <p v-if="project_is_created" class="form-input__error">
          Источник с таким названием уже создан
        </p>
      </z-form-group>
      <z-form-group class="row form-group--modal align-items-baseline z-form-item">
        <z-form-input class="col-12" :rules="{ required: true }">
          <v-autocomplete
            v-model="form.type"
            :items="typeList"
            item-text="name"
            item-value="id"
            hide-details="auto"
            :label="$t('projects.create_task.modal_add_source.form.type')"
            :value="value"
            outlined
            dense
          />
        </z-form-input>
      </z-form-group>
      <z-form-group class="row form-group--modal align-items-baseline z-form-item">
        <z-form-input class="col-12" :rules="{ required: true }">
          <v-autocomplete
            v-model="form.group_id"
            :items="groupList"
            item-text="name"
            item-value="id"
            hide-details="auto"
            :label="$t('projects.create_task.modal_add_source.form.group')"
            :value="value"
            outlined
            dense
            @input="update_group_info"
          />
          <p class="mt-2">
            <span v-if="processing_mode">
              {{ $t(`projects.create_task.modal_add_source.method.${processing_mode}`) }}
            </span>
            <span v-if="users_in_group.length > 0">
              {{ $t('shared.users') }}:
              <template v-for="(name, i) in users_in_group">
                <template v-if="i < 2"> {{ name.name }}, </template>
                <template v-if="i === 2">
                  {{ name.name }}
                </template>
              </template>
              <template v-if="users_in_group.length > 2">
                <span class="pointer bold" @click="toGroup">
                  {{ $t('shared.and_more') }} {{ users_in_group.length - 3 }}
                </span>
              </template>
            </span>
          </p>
        </z-form-input>
      </z-form-group>
    </z-form>
    <template #footer-cancel="{ close }">
      <v-btn class="btn-cancel" color="#fff" ref="close" @click="close()">
        {{ $t('shared.component.button.cancel') }}
      </v-btn>
    </template>
    <v-btn
      slot="footer-ok"
      class="btn-success"
      raised
      color="#394858"
      size="large"
      :loading="is_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </v-btn>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import { GroupService } from '@administration/services/GroupService';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';

  export default {
    components: { BaseModal },
    props: {
      item: {
        type: [Array, Object],
        default: () => []
      },
      exist_name: {
        type: [Array, Object],
        default: () => []
      },
      is_edit: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      form: {
        name: '',
        type: 'api',
        group_id: ''
      },
      typeList: [{ id: 'api', name: 'API' }],
      groupList: {},
      users_in_group: [],
      processing_mode: '',
      name_old: '',
      is_loading: false,
      project_is_created: false,
      project_exists: false,
      source_list: []
    }),
    watch: {
      item: {
        handler: function (val) {
          if (this.is_edit) {
            this.form = defaultsDeep(pick(val, ['name', 'type', 'group_id']), {
              name: '',
              type: '',
              group_id: ''
            });
          }
        },
        immediate: true,
        deep: true
      }
    },
    mounted() {
      this.form.type = this.typeList[0].id;
    },

    async created() {
      this.$store.getters[`sources/table/data`].forEach((data) => {
        this.source_list.push(data.name);
      });
      await GroupService.getList().then((resp) => (this.groupList = resp.data));
      if (!this.is_edit) {
        this.form.group_id = this.groupList[0].id;
      }
      this.name_old = this.form.name;
      this.update_group_info();
      this.source_list.push(...this.exist_name);
    },

    methods: {
      toGroup() {
        this.$refs.close.$el.click();
        setTimeout(() => {
          this.$router.push({
            name: 'administration.usergroup.index',
            params: { groupId: this.form.group_id }
          });
        }, 300);
      },
      compare_names_projects() {
        this.source_list.every((item) => {
          if (this.form.name == item) {
            this.project_is_created = true;
            this.project_exists = true;
            return false;
          } else {
            this.project_is_created = false;
            this.project_exists = false;
          }
        });
      },

      save() {
        this.compare_names_projects();
        if (this.project_exists === true) return false;
        this.$refs.form
          .validate()
          .then((is_valid) => {
            if (is_valid) {
              this.is_loading = true;
              const R = this.$R;
              const select_group = R.find(R.propEq('id', this.form.group_id))(this.groupList);
              const { group_id, name, type } = this.form;
              const source_data = {
                group_id,
                group: {
                  name: select_group.name
                },
                key: false,
                name,
                type,
                created_at: Date.now(),
                name_old: this.name_old
              };
              this.$emit('success', source_data);
            }
          })
          .catch((error) => this.$noty.server_error(error));
      },

      update_group_info() {
        GroupService.getFullList(this.form.group_id).then((resp) => {
          this.processing_mode = resp.processing_mode;
          this.users_in_group = resp.users;
        });
      }
    }
  };
</script>
